import { useTranslation } from 'react-i18next';
import { Download, Edit2, Link2, MoreVertical, Share2, Trash2 } from 'lucide-react';
import {
  ActionMenu,
  Button,
  IconButton,
  Tooltip,
} from '@ntconsult/aluma-react';

interface FolderHeaderActionsProps {
  /** Indica se o usuário pode renomear/excluir (owner ou admin). */
  canEdit: boolean;
  /** Indica se o usuário pode compartilhar a pasta. */
  canShare: boolean;
  onShare: () => void;
  onCopyLink: () => void;
  onDownload: () => void;
  onRename: () => void;
  onDelete: () => void;
}

export function FolderHeaderActions({
  canEdit,
  canShare,
  onShare,
  onCopyLink,
  onDownload,
  onRename,
  onDelete,
}: FolderHeaderActionsProps) {
  const { t } = useTranslation(['folders', 'common']);

  return (
    <div className="flex items-center gap-2">
      <Tooltip content={t('folders:actions.copyLink')}>
        <IconButton
          variant="ghost"
          label={t('folders:actions.copyLink')}
          icon={<Link2 className="w-4 h-4" aria-hidden="true" />}
          onClick={onCopyLink}
        />
      </Tooltip>

      <Tooltip content={t('folders:actions.download')}>
        <IconButton
          variant="ghost"
          label={t('folders:actions.download')}
          icon={<Download className="w-4 h-4" aria-hidden="true" />}
          onClick={onDownload}
        />
      </Tooltip>

      {canShare && (
        <Button
          variant="secondary"
          onClick={onShare}
          leftIcon={<Share2 className="w-4 h-4" aria-hidden="true" />}
          aria-label={t('folders:actions.share')}
        >
          <span className="hidden sm:inline">{t('folders:actions.share')}</span>
        </Button>
      )}

      {canEdit && (
        <ActionMenu
          align="right"
          trigger={
            <IconButton
              variant="ghost"
              label={t('folders:actions.more')}
              icon={<MoreVertical className="w-4 h-4" aria-hidden="true" />}
            />
          }
        >
          <ActionMenu.Item
            icon={<Edit2 className="w-4 h-4" aria-hidden="true" />}
            onClick={onRename}
          >
            {t('folders:actions.rename')}
          </ActionMenu.Item>
          <ActionMenu.Separator />
          <ActionMenu.Item
            variant="danger"
            icon={<Trash2 className="w-4 h-4" aria-hidden="true" />}
            onClick={onDelete}
          >
            {t('folders:actions.delete')}
          </ActionMenu.Item>
        </ActionMenu>
      )}
    </div>
  );
}
